module.exports = __webpack_public_path__ + "ng.svg?3c54ce297ccceec2e2c85c0349975fa3";